import Model from "./Model";

export default class Aviso extends Model {
  constructor(aviso) {
    super();
    Object.assign(this, aviso);
  }
}
